import React, { useContext, useEffect, useState } from "react";
import AppContainer from "../Components/Structure/AppContainer";
import DashboardStatistics from "../Components/Dashboard/DashboardStatistics";
import SchoolContext from "../Context/SchoolContext";
import ContactContext from "../Context/ContactContext";
import CallsCategoriesChart from "../Components/Dashboard/CallsCategoriesChart";
import ajaxBank from "../util/remote/ajaxBank";
import ajaxStudent from "../util/remote/ajaxStudent";
import ajaxCallStation from "../util/remote/ajaxCallStation";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import ajaxParent from "../util/remote/ajaxParent";
import { Link } from "react-router-dom";
import ajaxUser from "../util/remote/ajaxUser";
// import Loader from "../Components/Common/Loader";

function Dashboard() {
  const { schoolsNumber } = useContext(SchoolContext);
  const { contactsNumber } = useContext(ContactContext);
  const [buzzTimeTotal, setBuzzTimeTotal] = useState(false);
  const [pocketMoneyTotal, setPocketMoneyTotal] = useState(false);
  const [accountActivationTotal, setAccountActivationTotal] = useState(false);
  const [allActivationsCount, setAllActivationsCount] = useState(false);
  const [buzzChatsPerCategory, setBuzzChatsPerCategory] = useState(false);
  const [gsmCount, setGSMCount] = useState(false);
  const [totalCallsPerCategory, setTotalCallsPerCategory] = useState(false);
  // const [loading2, setLoading2] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [loading3, setLoading3] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [vendorDisbursements, setVendorDisbursements] = useState([]);
  const [recentSignups, setRecentSignups] = useState([]);
  const [recentActivations, setRecentActivations] = useState([]);

  // useEffect(() => {
  //   getBuzzTimeTotal();
  //   getPocketMoneyTotal();
  //   getAccountActivationsTotal();
  //   countAllActivations();
  //   getBuzzChatsPerCategory();
  //   getGSMCount();
  //   getCallsPerCategory();
  //   getRecentDisbursements();
  //   getRecentSignups();
  //   getRecentActivations();

  // }, []);

  useEffect(() => {
  const fetchAll = async () => {
    setLoadingPage(true);
    await Promise.all([
      getBuzzTimeTotal(),
      getPocketMoneyTotal(),
      getAccountActivationsTotal(),
      countAllActivations(),
      getBuzzChatsPerCategory(),
      getGSMCount(),
      getCallsPerCategory(),
      getRecentDisbursements(),
      getRecentSignups(),
      getRecentActivations(),
    ]);
    setLoadingPage(false);
  };

  fetchAll();
}, []);

  const getCallsPerCategory = async () => {
    const server_response = await ajaxCallStation.countLogsPerCategory();
    if (server_response.status === "OK") {
      setTotalCallsPerCategory(server_response.details);
    } else {
      setTotalCallsPerCategory("404");
    }
  };

  const getBuzzChatsPerCategory = async () => {
      const server_response = await ajaxCallStation.buzzMessagesPerCategory();
      if (server_response.status === "OK") {
        setBuzzChatsPerCategory(server_response.details);
      } else {
        setBuzzChatsPerCategory("404");
      }
  };

  const getBuzzTimeTotal = async () => {
      const server_response = await ajaxBank.fetchBuzzTimeTotal();
      if (server_response.status === "OK") {
        setBuzzTimeTotal(server_response.details);
      } else {
        setBuzzTimeTotal("404");
      }
  };

  const getGSMCount = async () => {
      const server_response = await ajaxCallStation.countGSMMessages();
      if (server_response.status === "OK") {
        setGSMCount(server_response.details);
      } else {
        setGSMCount("404");
      }
  };

  const getPocketMoneyTotal = async () => {
    const server_response = await ajaxBank.fetchPocketMoneyTotal();
    if (server_response.status === "OK") {
      setPocketMoneyTotal(server_response.details);
    } else {
      setPocketMoneyTotal("404");
    }
};

const getAccountActivationsTotal = async () => {
    const server_response = await ajaxBank.fetchAccountActivationsTotal();
    if (server_response.status === "OK") {
      setAccountActivationTotal(server_response.details);
    } else {
      setAccountActivationTotal("404");
    }
};

const countAllActivations = async () => {
    const server_response = await ajaxStudent.countAllActivations();
    if (server_response.status === "OK") {
      setAllActivationsCount(server_response.details);
    } else {
      setAllActivationsCount("404");
    }
  };

  const getRecentDisbursements = async () => {
      const server_response = await ajaxBank.fetchRecentVendorDisbursements();
      if (server_response.status === "OK") {
        setVendorDisbursements(server_response.details);
      } else {
        setVendorDisbursements([]);
      }
  };

  const getRecentSignups = async () => {
      const server_response = await ajaxParent.listRecentSignups();
      if (server_response.status === "OK") {
        setRecentSignups(server_response.details);
      } else {
        setRecentSignups([]);
      }
  };

  const getRecentActivations = async () => {
      const server_response = await ajaxUser.fetchRecentDashboardActivations();
      if (server_response.status === "OK") {
        setRecentActivations(server_response.details);
      } else {
        setRecentActivations([]);
      }
  };

  return (
    <AppContainer title="Dashboard">
      {loadingPage ? (
        // Full page skeleton loader
        <div style={{ padding: 40 }}>
          <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
          <Skeleton height={200} style={{ marginBottom: 20 }} />
          <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
        </div>
      ) : (<>
      <div className="row row-sm">
        <div className="col-sm-12 col-xl-12">
          <div className="row">
              {/* Dashboard Statistics */}
              <DashboardStatistics
              schoolsNumber={schoolsNumber}
              contactsNumber={contactsNumber}
              studentsNumber={allActivationsCount}
            />
          </div>

            
        </div></div>
        <div className="row row-sm">
        <div className="col-lg-8 col-md-12 col-12 col-sm-12 mt-lg-0 mt-sm-4">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                <div class="card">
                  <div class="card-body">

                    <CallsCategoriesChart/>
                    <div class="mb-4 mt-4">
                <div class="text-small float-right font-weight-bold text-muted">{totalCallsPerCategory?.totals?.gsm?.total_p}</div>
                <div class="">Direct Calls</div>
                <div class="progress" data-height="5">
                  <div class="progress-bar l-bg-green" role="progressbar" style={{width:"85%"}}></div>
                </div>
              </div>
              <div class="mb-4">
                <div class="text-small float-right font-weight-bold text-muted">{totalCallsPerCategory?.totals?.buzz_voice?.total_p}</div>
                <div class="">Buzz Voice Calls</div>
                <div class="progress" data-height="5">
                  <div class="progress-bar bg-light-blue" role="progressbar" style={{width:"30%"}}></div>
                </div>
              </div>
              <div class="mb-4">
                <div class="text-small float-right font-weight-bold text-muted">{totalCallsPerCategory?.totals?.buzz_video?.total_p}</div>
                <div class="">Buzz Video Calls</div>
                <div class="progress" data-height="5">
                  <div class="progress-bar l-bg-orange" role="progressbar" style={{width:"10%"}}></div>
                </div>
              </div>
                  </div>
                </div></div>
                <div className="col-lg-7 col-md-12 col-12 col-sm-12">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Recent Vendor Disbursements</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table">
                    <thead>
                      <tr>
                        <th className="wd-15p">Date</th>  
                        <th className="wd-15p">Vendor Details</th>
                        <th className="wd-15p">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                   
                      {vendorDisbursements.length > 0 ? (
                        vendorDisbursements.map((item, index) => (
                      <tr key={index}>
                        <td class="bd-t-0">
                                                                        <h6 class="mg-b-0">
                                                                          
                                                                        {item.created_at?.short_date}
                                                                            
                                                                        </h6>
                                                                        <small class="tx-11 tx-gray-500">{item.created_at?.time}</small>
                                                                    </td>
                        <td class="bd-t-0">
                                                                        <h6 class="mg-b-0">
                                                                         
                                                                       {item.user}
                                                                            
                                                                        </h6>
                                                                        <small class="tx-11 tx-gray-500">{item.phone_number}</small>
                                                                    </td>
                        <td class="bd-t-0">
                                                                        <h6 class="mg-b-0" style={{fontSize:"14px"}}>
                                                                          
                                                                       UGX.{item.amount}
                                                                            
                                                                        </h6>
                                                                        <small class="tx-11 tx-gray-500"><span className={`badge ${item.status === "3" ? "badge-success" : item.status === "1" ? "badge-warning" : "badge-danger"}`}>
                        {item.status === "3" ? "SUCCESSFUL" : item.status === "1" ? "PENDING" : "FAILED"}
                      </span></small>
                                                                    </td>
                        
                      </tr>))
                      ) : (
                        <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                            No recent vendor disbursements.
                        </td>
                        </tr>
                        )}
                     
                      
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
           
           
          
                </div>
                <div className="col-lg-5 col-md-12 col-12 col-sm-12">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Recent App Signups</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table">
                    <tbody>
                    {recentSignups.length > 0 ? (
                        recentSignups.map((item, index) => (
                      <tr key={index}>
                        <td class="bd-t-0">
                              <div class="main-img-user"><img alt="avatar" style={{ height: "30px" }} src={
                                                          process.env.PUBLIC_URL + "/assets/img/figure/user55.png"}/>
                                </div>
                            </td>
                            
                                                                    <td class="bd-t-0">
                                                                        <h6 class="mg-b-0">
                                                                           <Link to={`/parents/profile/${item.parent_id}/${item.user_id}`}>
                                                                       {item.full_name}</Link>
                                                                            
                                                                        </h6>
                                                                        <small class="tx-11 tx-gray-500">{item.username}</small>
                                                                    </td>
                        
                        
                      </tr>))
                      ) : (
                        <tr>
                        <td colSpan="2" style={{ textAlign: "center" }}>
                            No recent app signups.
                        </td>
                        </tr>
                        )}
                        <tr>
                          <td class="bd-t-0">
                             
                            </td>
                                      
                                      <td className="bd-t-0"><Link  to="/contacts">
                                          <small>View all  <i className="fa fa-angles-right mr-2"></i></small>
                                        </Link></td>
                                    </tr>
                  
                      
                    </tbody>
        
                  </table></div>
                </div>
              </div>
           
           
          
        </div>
                
                
                </div>
                
                
              

            
        </div>
        <div className="col-lg-4 col-md-12 col-12 col-sm-12">
          <div className="row">
        
        
              <div class="col-lg-12 col-md-12 col-12 col-sm-12">
                <div class="card custom-card">
                  
                  <div class="card-body">
                  <h6 style={{ marginBottom: 10 }}>Cumulative Deposits</h6>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">UGX. {accountActivationTotal? accountActivationTotal.total_account_activations_c : "..."}</div>
                      <div class="">Account Activations</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar l-bg-green" role="progressbar" style={{width:"30%"}}></div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">UGX. {pocketMoneyTotal?pocketMoneyTotal:"..."}</div>
                      <div class="">Pocket Money Deposits</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar bg-light-blue" role="progressbar" style={{width:"90%"}}></div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">UGX. {buzzTimeTotal ? buzzTimeTotal : "..."}</div>
                      <div class="">Buzztime Credit</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar l-bg-orange" role="progressbar" style={{width:"40%"}}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-12 col-sm-12">
                <div class="card custom-card">
                  
                  <div class="card-body">
                  <h6 style={{ marginBottom: 10 }}>Buzz Chats / Messages</h6>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">{buzzChatsPerCategory?buzzChatsPerCategory.totals?.buzz_text?.total_p:"..."}</div>
                      <div class="">Buzz Text Chats</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar l-bg-green" role="progressbar" style={{width:"80%"}}></div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">{buzzChatsPerCategory?buzzChatsPerCategory.totals?.buzz_voice?.total_p:"..."}</div>
                      <div class="">Buzz Voice Notes</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar bg-light-blue" role="progressbar" style={{width:"20%"}}></div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">{gsmCount?.total_p}</div>
                      <div class="">Direct Messages</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar l-bg-orange" role="progressbar" style={{width:"30%"}}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-12 col-sm-12">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Recent Account Activations</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table">
                    <tbody>
                    {recentActivations.length > 0 ? (
                        recentActivations.map((item, index) => (
                      <tr key={index}>
                        
                                              <td class="bd-t-0">
                                                                        <h6 class="mg-b-0">
                                                                          
                                                                        {item.created_at?.short_date}
                                                                            
                                                                        </h6>
                                                                        <small class="tx-11 tx-gray-500">{item.created_at?.time}</small>
                                                                    </td>
                                                                    <td class="bd-t-0">
                                                                        <h6 class="mg-b-0">
                                                                         <Link to={`/students/profile/${item.student_id}/${item.user_id}`}>
                                                                        {item.last_name} {item.first_name}</Link> 
                                                                            
                                                                        </h6>
                                                                        <small class="tx-11 tx-gray-500">{item.school_name}</small>
                                                                    </td>
                        
                        
                      </tr>))
                      ) : (
                        <tr>
                        <td colSpan="2" style={{ textAlign: "center" }}>
                            No recent account activations.
                        </td>
                        </tr>
                        )}
                        <tr>
                                      <td className="bd-t-0">
                                        <Link  to="/account-activations">
                                          <small>View all  <i className="fa fa-angles-right mr-2"></i></small>
                                        </Link>
                                      </td>
                                      <td className="py-2 px-0"></td>
                                    </tr>
                    
                      
                      
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
           
           
          
        </div>
        </div></div>
      </div></>) }
      
      
      

    </AppContainer>
  );
}

export default Dashboard;